import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';
import Select from "react-select";

export class SetOfDayTypesForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            setOfDayTypes: this.props.setOfDayTypes,
            nameInputError: null
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { setOfDayTypes } = this.state;

        setOfDayTypes[property] = e.target.value;

        this.setState({
            setOfDayTypes: setOfDayTypes
        });
    }

    onSelectValue(e, property) {
        const { setOfDayTypes } = this.state;

        setOfDayTypes[property] = e;

        this.setState({
            setOfDayTypes: setOfDayTypes
        });
    }

    onSave() {
        if (this.validInput()) {
            const { setOfDayTypes } = this.state;
            this.props.onSave(setOfDayTypes);
        }
    }

    validInput() {
        let errors = 0;
        let nameInputError = null;

        const { setOfDayTypes } = this.state;

        if ("" === setOfDayTypes.name || null === setOfDayTypes.name || undefined === setOfDayTypes.name) {
            nameInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError: nameInputError
        });

        return errors > 0 ? false : true;
    }

    // -------------------

    render() {
        const { setOfDayTypes, nameInputError } = this.state;
        
        if (undefined === setOfDayTypes || null === setOfDayTypes) {
            return null;
        }
        
        const { title, dayTypes } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={setOfDayTypes.name}
                                placeholder="Name"
                                onChange={(e) => this.onChangeValue(e, "name")} />

                            {nameInputError !== null ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formDayTypes">
                            <ControlLabel>Tipos de Dia</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder='Selecione os Tipos de Dia...'
                                onChange={(e) => this.onSelectValue(e, 'dayTypes')}
                                options={dayTypes}
                                isMulti={true}
                                isOptionSelected={function (a) {
                                    if (undefined !== setOfDayTypes.dayTypes) {
                                        return setOfDayTypes.dayTypes.map(dayType => dayType.id).includes(a.id);
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={setOfDayTypes.dayTypes}
                            />
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/setOfDayTypes/SetOfDayTypesForm.js